module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }